// noinspection JSUnusedGlobalSymbols

import {MatToolbarModule} from '@angular/material/toolbar';
import {CommonModule, DOCUMENT, NgClass,} from '@angular/common';
import {AfterViewInit, Component, Inject, OnDestroy, OnInit, Renderer2, ViewChild,} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {InConfiguration} from '@core';
import {UnsubscribeOnDestroyAdapter} from '@shared';
import {MatMenuModule, MatMenuTrigger} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {AuthManagementService} from '@core/service/auth-management.service';
import {PatientDetails} from '@core/models/PatientDetails';
import {BusinessGroup} from '@core/models/BusinessGroup';
import {DefaultResponse} from '@core/models/Http/DefaultResponse';
import {CatalogsService} from '@core/http/catalogs.service';
import {BusinessGroupService} from '@core/service/business-group.service';
import {Branch} from "@core/models/Branch";
import {BranchGroupService} from "@core/service/branch-group.service";
import {FeatherIconsComponent} from "@shared/components/feather-icons/feather-icons.component";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";
import {MatDivider} from "@angular/material/divider";
import Swal from "sweetalert2";
import {environment} from "@enviroment/environment";
import {HttpClient} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {NoticiasAlertaModalComponent} from "@shared/noticias-alerta-modal/noticias-alerta-modal.component";
import {distinctUntilChanged} from "rxjs";
import {GEMPService} from "@core/http/table-data-services/GEMP.service";
import {MatTooltip} from "@angular/material/tooltip";
import {TourUiBridgeService} from "@core/service/tour-ui-bridge.service";
import { GuidedTourService, RmdTourId } from '@core/service/guided-tour.service';
import { MatBadgeModule } from '@angular/material/badge';
import { NotificationRealtimeService } from '@core/service/notification-realtime.service';
import {
  NotificationDetailDialogComponent
} from "@shared/components/notification-detail-dialog/notification-detail-dialog.component";
import {RegionWordPipe} from "@core/pipes/region-word.pipe";
import { LegalPoliciesDialogComponent } from '@shared/components/legal-policies-dialog/legal-policies-dialog.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    NgClass,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatToolbarModule,
    CommonModule,
    FeatherIconsComponent,
    MatDivider,
    MatTooltip,
    MatBadgeModule,
    RegionWordPipe
  ],
})
export class HeaderComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit, AfterViewInit, OnDestroy {

  public config!: InConfiguration;
  userName?: string;
  userImage?: string;
  private lastLoadedBranchesGempId = '';

  unreadCount$ = this.realtimeNoti.unreadCount$;
  notifications$ = this.realtimeNoti.notifications$;

  homePage = '/dashboard';
  isNavbarCollapsed = true;

  flagvalue: string | string[] | undefined;
  countryName: string | string[] = [];
  langStoreValue?: string;
  defaultFlag?: string;
  docElement?: HTMLElement;

  businessGroups: BusinessGroup[] = [];
  branches: Branch[] = [];
  alertTypes: any[] = [];

  businessGroupId: string = '';
  branchGroupId: string = '';

  isAdmin: boolean = false;
  isSupervisor: boolean = false;
  isPaciente: boolean = false;
  isDoctor: boolean = false;
  isParticular: boolean = false;

  availableTours: Array<{ id: RmdTourId; title: string; description?: string }> = [];

  listLang = [
    {text: 'English', flag: 'assets/images/flags/us.svg', lang: 'en'},
    {text: 'Spanish', flag: 'assets/images/flags/spain.svg', lang: 'es'},
    {text: 'German', flag: 'assets/images/flags/germany.svg', lang: 'de'},
  ];

  data: PatientDetails[] = [];

  @ViewChild('profileMenuTrigger', { read: MatMenuTrigger })
  public profileMenuTrigger!: MatMenuTrigger;

  @ViewChild('notiTrigger', { read: MatMenuTrigger })
  public notiTrigger!: MatMenuTrigger;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private authManagement: AuthManagementService,
    private catalogsService: CatalogsService,
    private businessGroupService: BusinessGroupService,
    private branchGroupService: BranchGroupService,
    private router: Router,
    private httpMsgHandler: HttpMesageHandlerService,
    private http: HttpClient,
    private dialog: MatDialog,
    private gempService: GEMPService,
    private guidedTour: GuidedTourService,
    private tourUi: TourUiBridgeService,
    private realtimeNoti: NotificationRealtimeService,
  ) {
    super();
  }

  ngOnInit() {
    this.initLanguage();
    this.initUserData();

    this.subscribeToBusinessGroupId();
    this.loadBusinessGroupId();
    this.loadBranchGroupId();
    this.subscribeToBranchGroupId();

    // ✅ PARTICULAR: no depende de grupos, carga sucursales por usuario autenticado
    if (this.isParticular) {
      this.getSucursalesPorUsuario();
    } else {
      this.getBusinessGroups();
      this.subs.sink = this.gempService.refreshGroups$.subscribe(() => this.getBusinessGroups());
    }

    if (!this.isPaciente && environment.region === 'ES') {
      this.fetchAlertTypes();
    }

    setTimeout(() => {
      this.availableTours = this.guidedTour.getAvailableTours();
    }, 0);
  }

  startTour(id: RmdTourId): void {
    this.guidedTour.startTour(id, { force: true });
  }

  ngAfterViewInit(): void {
    this.tourUi.setProfileTrigger(this.profileMenuTrigger);
  }

  override ngOnDestroy(): void {
    this.tourUi.setProfileTrigger(null);
    super.ngOnDestroy();
  }

  mobileMenuSidebarOpen(event: Event, className: string) {
    const hasClass = (event.target as HTMLInputElement).classList.contains(className);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }

  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
      localStorage.setItem('collapsed_menu', 'false');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
      localStorage.setItem('collapsed_menu', 'true');
    }
  }

  getBusinessGroups(): void {
    if (this.isParticular) {
      this.businessGroups = [];
      return;
    }

    this.catalogsService.getBusinessGroups().subscribe({
      next: (res: DefaultResponse<BusinessGroup[]>) => {
        const groups = res.data ?? [];
        if (!groups.length) return;

        this.businessGroups = [...groups].sort(this.sortBusinessGroups);

        if (!this.businessGroupId) {
          const defaultB = this.businessGroups[0].idGEMP;
          this.changeBusinessGroupId(defaultB);
        }
      },
      error: (error) => {
        this.httpMsgHandler.handleMsg(error);
      }
    });
  }

  getSucursalesIdGemp(idGemp: string) {
    if (!idGemp || this.lastLoadedBranchesGempId === idGemp) return;

    this.lastLoadedBranchesGempId = idGemp;

    this.catalogsService.getBranchesByIdGEMP(idGemp).subscribe({
      next: (res: DefaultResponse<Branch[]>) => {
        const branches = res.data ?? [];
        if (!branches.length) {
          this.branches = [];
          return;
        }

        this.branches = [...branches].sort(this.sortBranchesByName);

        if (this.isAdmin || this.isSupervisor) {
          this.branchGroupId = '';
          this.branchGroupService.setBranchGroupId('');
          localStorage.removeItem('branchGroupId');
          return;
        }

        if (!this.branchGroupId && this.branches.length) {
          const firstBranchId = this.branches[0].idSucursal;

          this.branchGroupId = firstBranchId;
          this.branchGroupService.setBranchGroupId(firstBranchId);
          localStorage.setItem('branchGroupId', firstBranchId);
        }
      },
      error: (error) => this.httpMsgHandler.handleMsg(error),
    });
  }

  getSucursalesPorUsuario(): void {
    this.catalogsService.getBranchesByAuthenticatedUser().subscribe({
      next: (res: DefaultResponse<Branch[]>) => {
        const branches = res.data ?? [];
        this.branches = [...branches].sort(this.sortBranchesByName);

        // En particular sí conviene restaurar o elegir una por default
        if (!this.branchGroupId && this.branches.length) {
          const firstBranchId = this.branches[0].idSucursal;
          this.changeBranchGroupId(firstBranchId);
        }
      },
      error: (error) => {
        this.branches = [];
        this.httpMsgHandler.handleMsg(error);
      }
    });
  }

  changeBusinessGroupId(id: string): void {
    if (!id || id === this.businessGroupId) return;

    this.businessGroupService.changeGempAndRefreshToken(id).subscribe({
      next: () => {
        this.businessGroupId = id;

        if (this.isAdmin || this.isSupervisor) {
          if (this.branchGroupId !== '') {
            this.branchGroupId = '';
            this.branchGroupService.setBranchGroupId('');
          }
          localStorage.removeItem('branchGroupId');
        }
      },
      error: (err) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  changeBranchGroupId(id: string | null | undefined): void {
    const next = id ?? '';
    if (next === this.branchGroupId) return;

    this.branchGroupService.setBranchGroupId(next);
    this.branchGroupId = next;

    if (next) localStorage.setItem('branchGroupId', next);
    else localStorage.removeItem('branchGroupId');
  }

  logout() {
    this.authManagement.logout$().subscribe();
  }

  profile() {
    this.router.navigate(['/user/profile']).then();
  }

  fetchAlertTypes() {
    this.http.post<any>(`${environment.backend_url}VIDAL_Tools/getTiposDeAlertas`, {})
      .subscribe({
        next: (res) => {
          const allAlerts = Array.isArray(res) ? res : res.data || [];
          this.alertTypes = allAlerts.filter((alerta: { type: number; }) =>
            alerta.type >= 1 && alerta.type <= 5
          );
        },
        error: () => {
          this.alertTypes = [];
        }
      });
  }

  openAlertType(alertType: any) {
    this.http.post<any>(
      `${environment.backend_url}VIDAL_Tools/getAlertaByTipo`,
      JSON.stringify({ type: alertType.type }),
      {
        headers: {'Content-Type': 'application/json'},
        responseType: 'json'
      }
    ).subscribe({
      next: (res: any) => {
        const noticiasData = Array.isArray(res.data) ? res.data : [];

        const noticias = noticiasData.map((item: { json: string }) => {
          let parsed: any = {};
          try {
            parsed = JSON.parse(item.json);
          } catch {
            parsed = {};
          }
          return parsed;
        });

        this.dialog.open(NoticiasAlertaModalComponent, {
          data: {noticias, tipo: alertType.type},
          width: '90vw',
          minWidth: '90vw',
          maxWidth: '90vw',
          minHeight: '90vh',
          maxHeight: '90vh'
        });
      },
      error: () => {
        Swal.fire('Error', 'No se pudieron obtener las alertas/noticias', 'error').then();
      }
    });
  }

  openLegalPolicies(): void {
    this.dialog.open(LegalPoliciesDialogComponent, {
      width: '92vw',
      maxWidth: '1080px',
      maxHeight: '88vh',
      autoFocus: false,
      panelClass: 'rmd-dialog-premium',
    });
  }

  private sortBusinessGroups(a: BusinessGroup, b: BusinessGroup): number {
    if (!a.logoBase64 && b.logoBase64) return 1;
    if (a.logoBase64 && !b.logoBase64) return -1;
    return a.nombre.localeCompare(b.nombre);
  }

  private sortBranchesByName(a: Branch, b: Branch): number {
    return a.nombre.localeCompare(b.nombre);
  }

  private initLanguage() {
    this.langStoreValue = localStorage.getItem('lang') as string;
    const lang = this.listLang.find(x => x.lang === this.langStoreValue);
    if (lang) {
      this.countryName = [lang.text];
      this.flagvalue = [lang.flag];
    } else {
      this.defaultFlag = 'assets/images/flags/us.svg';
    }
  }

  private initUserData() {
    const userData = this.authManagement.userData();

    this.userName = localStorage.getItem('userName') || '';
    this.isAdmin = this.authManagement.isUserAdmin();
    this.isSupervisor = this.authManagement.isUserPharmacySupervision();
    this.isPaciente = this.authManagement.isUserPatient();
    this.isDoctor = this.authManagement.isUserDoctor();
    this.isParticular = this.authManagement.isUserParticular();

    this.userImage = userData.Imagen
      ? 'data:image/png;base64,' + userData.Imagen
      : 'assets/images/user/imgUSer.png';

    if (!this.businessGroupId && this.businessGroups.length) {
      this.businessGroupId = this.businessGroups[0].idGEMP;
    }

    if (!this.branchGroupId && this.branches.length && !(this.isAdmin || this.isSupervisor)) {
      this.branchGroupId = this.branches[0].idSucursal;
    }
  }

  private subscribeToBusinessGroupId() {
    this.businessGroupService.businessGroupId$
      .pipe(distinctUntilChanged())
      .subscribe(id => {
        if (!id) return;

        this.businessGroupId = id;

        if (this.isAdmin || this.isSupervisor) {
          this.getSucursalesIdGemp(id);
        }
      });
  }

  private subscribeToBranchGroupId() {
    this.branchGroupService.branchGroupId$
      .pipe(distinctUntilChanged())
      .subscribe(id => {
        // ✅ aquí sí permitimos vacío solo si no hay selección
        this.branchGroupId = id ?? '';
      });
  }

  private loadBusinessGroupId() {
    if (this.isParticular) {
      this.businessGroupId = '';
      localStorage.removeItem('businessGroupId');
      return;
    }

    const stored = localStorage.getItem('businessGroupId');
    if (stored) {
      this.businessGroupId = stored;
      this.businessGroupService.setBusinessGroupId(stored);
    }
  }

  private loadBranchGroupId() {
    const stored = localStorage.getItem('branchGroupId');

    // ADMIN/SUPERVISOR no restauran sucursal
    if (this.isAdmin || this.isSupervisor) {
      this.branchGroupId = '';
      this.branchGroupService.setBranchGroupId('');
      localStorage.removeItem('branchGroupId');
      return;
    }

    // ✅ Particular sí puede restaurar sucursal
    if (stored) {
      this.branchGroupId = stored;
      this.changeBranchGroupId(stored);
    }
  }

  markNotiRead(): void {
    this.realtimeNoti.markAllAsRead();
    try { this.notiTrigger?.closeMenu(); } catch {}
  }

  onNotiMenuOpened(): void {
    // this.realtimeNoti.markAllAsRead();
  }

  openNotification(n: any): void {
    try { this.notiTrigger?.closeMenu(); } catch {}

    setTimeout(() => {
      this.dialog.open(NotificationDetailDialogComponent, {
        data: { notification: n },
        width: '92vw',
        maxWidth: '560px',
        panelClass: 'rmd-dialog-premium',
        autoFocus: false
      });

      if (n?._id) {
        this.realtimeNoti.markAsReadAndRemove(n._id);
      }
    }, 80);
  }

  recargarGrupos() {
    if (!this.isParticular) {
      this.getBusinessGroups();
    }
  }
}
